import template from './wizard_leave_setup_description.html';

class WizardLeaveSetupDescription
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.leave_type_id = ko.observable(null);
		this.leave_type_plugin_context = ko.observableArray();
		this.icons = ko.observableArray();
		this.categories = ko.observableArray();
		this.colors = ko.observableArray();
		this.plugin_context = ko.observable();
		this.description = ko.observable();
		this.icon = ko.observable('fas fa-umbrella-beach');
		this.category = ko.observable();
		this.hexcolor = ko.observable('#CCCCCC');
		this.color_name = ko.observable('Light grey');
	};

	select_icon(data)
	{
		this.icon(data.icon);
	}

	select_color(data)
	{
		this.hexcolor(data.hexcolor);
		this.color_name(data.name);
	}

	close()
	{
		this.dialog.close();
	}

	next_wizard()
	{
		//validation
		let message = '';
		let valid = true;
		
		if (!this.description())
		{
			message = tr('Please enter a description');
			valid = false
		}
		if (valid == false)
		{
			Grape.alerts.alert({type: 'error', message: message, title: tr('Error', 'Error')});
			return;
		}

		if (!this.dialog.bindings.leave_object)
			this.dialog.bindings.leave_object = {leave_type_id: 0} ;
	
		let data = Object.assign(this.dialog.bindings.leave_object, {
			plugin_context: this.plugin_context(),
			leave_type_id: 0,
			hexcolor: this.hexcolor(),
			description: this.description(),
			icon: this.icon(),
			category: this.category()
		});

		//go to next page
		Grape.dialog.open('WizardLeaveSetupCycle', { leave_object: data});

		this.dialog.close();
	};

	back()
	{
		this.dialog.close();
	};

	async back_and_save()
	{
		this.dialog.bindings.leave_object.plugin_context = this.plugin_context();
		this.dialog.bindings.leave_object.description = this.description();
		this.dialog.bindings.leave_object.icon = this.icon();
		this.dialog.bindings.leave_object.category = this.category();
		this.dialog.bindings.leave_object.hexcolor = this.hexcolor();

		let res = await Grape.fetches.postJSON('/admin/leave_type/save', this.dialog.bindings.leave_object);
		if (res.status === 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Changes has been saved'), title: tr('Success')});
			this.dialog.close();
		}
		else
			await Grape.alerts.apiError(res);
	}
};

class WizardLeaveSetupDescriptionPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardLeaveSetupDescription(this);
	}

	async init()
	{
		console.log('bindings', this.bindings);
		//Get dropdown data
		this.viewModel.icons(await Grape.cache.get('Icons'))
		this.viewModel.categories(await Grape.cache.get('LeaveCategory'))
		this.viewModel.colors(await Grape.cache.get('Colors'));

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_type_plugin_context',
			limit: 1000000
		});

		if (res.status !== 'ERROR')
			this.viewModel.leave_type_plugin_context(res.records);

		//Apply bindings if exists
		if (this.bindings.leave_object)
		{
			if (this.bindings.leave_object.leave_type_id)
				this.viewModel.leave_type_id(this.bindings.leave_object.leave_type_id);

			this.viewModel.description(this.bindings.leave_object.description || null);
			this.viewModel.icon(this.bindings.leave_object.icon);
			this.viewModel.hexcolor(this.bindings.leave_object.hexcolor);
			this.viewModel.category(this.bindings.leave_object.category);
			this.viewModel.plugin_context(this.bindings.leave_object.plugin_context);
			let color = this.bindings.leave_object.hexcolor;

			switch (color)
			{
				case '#CCCCCC':
					this.viewModel.color_name('Light grey');
					break;
				case '#ff8080':
					this.viewModel.color_name('Dark Pink');
					break;
				case '#ffb3d9':
					this.viewModel.color_name('Pink');
					break;
				case '#ff944d':
					this.viewModel.color_name('Orange');
					break;
				case '#94d896':
					this.viewModel.color_name('Light Green');
					break;
				case '#aee6f5':
					this.viewModel.color_name('Light Blue');
			}
		}
	};
};

export default {
	name: 'WizardLeaveSetupDescription',
	dialog_class: WizardLeaveSetupDescriptionPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_description',
	provider: 'ps'
};
